// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Dealers/Handlers/LoadDealers";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter = {
        ...props.apiParameter,
        pageSize: 50,
        additionalQueryStringParameters: {
            expand: "properties",
        },
    };
});
